<template>
  <div class="bottom-info">
    <div class="h-323 relative flex flex-col items-center justify-center">
      <img class="absolute left-0 top-0 w-full h-323" src="../assets/images/bot_banner1.png" />
      <div class="text-24px z-10 font-shs-medium">{{ title }}</div>
      <div class="text-18px mt-16 z-10">{{ subtitle }}</div>
      <div class="btn mt-40" @click="$refs.FreeUse.open()">{{ button }}</div>
    </div>
    <FreeUse ref="FreeUse" />
  </div>
</template>

<script>
import FreeUse from './FreeUse.vue'
export default {
  name: "BottomInfo",
  components: { FreeUse },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    button: {
      type: String,
      default: ""
    }
  }
};
</script>